import type { IconData } from '@stacksjs/iconify-core'

export const mailNotification: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path stroke-linecap=\"round\" d=\"M22 11.002c-6.88.021-11.621.26-14.512.472c-2.124.156-3.782 1.74-3.982 3.86C3.258 17.95 3 22.096 3 28s.258 10.05.506 12.667c.2 2.12 1.86 3.704 3.983 3.86C10.52 44.75 15.58 45 23 45c7.421 0 12.482-.25 15.51-.473c2.124-.156 3.784-1.74 3.984-3.86C42.742 38.05 43 33.903 43 28q0-2.153-.042-4\"/><path stroke-linecap=\"round\" d=\"M3 27c1.25.708 14.264 8 20 8s18.75-7.293 20-8\"/><path d=\"M36 3a9 9 0 1 1 0 18a9 9 0 0 1 0-18Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mailNotification
